import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Lock, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { AuthShell } from "@/pages/ForgotPassword";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { setError("Konfirmasi password tidak sama"); return; }
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      setDone(true);
      toast.success("Password berhasil diubah");
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) { setError(errMsg(err)); } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Buat Password Baru" subtitle="Masukkan password baru untuk akun Anda (minimal 6 karakter)." testId="reset-page">
      {!token ? (
        <div className="text-center text-sm text-rose-600" data-testid="reset-invalid">Tautan tidak valid. <Link to="/forgot-password" className="text-sky-700 font-semibold hover:underline">Ajukan permintaan baru</Link></div>
      ) : done ? (
        <div className="text-center" data-testid="reset-success">
          <div className="mx-auto h-14 w-14 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center"><CheckCircle2 className="h-7 w-7" /></div>
          <p className="mt-4 text-sm text-slate-700">Password berhasil diubah. Mengarahkan ke halaman login...</p>
          <Link to="/login" className="mt-4 inline-block text-sm text-sky-700 font-semibold hover:underline" data-testid="link-go-login">Login sekarang</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="pw" className="text-slate-700">Password Baru</Label>
            <div className="relative"><Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-sky-500" /><Input id="pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={6} className="h-12 pl-10 rounded-xl bg-white/90 border-sky-200" data-testid="input-reset-password" /></div>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="pw2" className="text-slate-700">Konfirmasi Password</Label>
            <div className="relative"><Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-sky-500" /><Input id="pw2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required minLength={6} className="h-12 pl-10 rounded-xl bg-white/90 border-sky-200" data-testid="input-reset-password2" /></div>
          </div>
          {error && <div className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-xl px-3 py-2" data-testid="reset-error">{error}</div>}
          <Button type="submit" disabled={loading} className="w-full h-12 rounded-xl bg-gradient-to-r from-sky-600 to-cyan-500 hover:from-sky-700 hover:to-cyan-600 font-semibold" data-testid="btn-reset-submit">{loading ? "Menyimpan..." : "Simpan Password Baru"}</Button>
        </form>
      )}
    </AuthShell>
  );
}
